// File: src/api/axios.js

import axios from 'axios';

const instance = axios.create({
    baseURL: 'https://ddhrms.com/api',

    headers: {
        'Content-Type': 'application/json',
    },

    withCredentials: false,
});

// Attach JWT token automatically
instance.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');

        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }

        return config;
    },
    (error) => Promise.reject(error)
);

// Global response handler
instance.interceptors.response.use(
    (response) => response,
    (error) => {
        if (error.response?.status === 401) {
            console.warn('Unauthorized - clearing storage and redirecting to login');

            localStorage.removeItem('token');
            localStorage.removeItem('user');

            window.location.href = '/login';
        }

        return Promise.reject(error);
    }
);

export default instance;